import { mergeKeyWith } from '../../../common/query'
import { AdresseQueryPayload } from '../types'

const getAdresseKeys = () => {
  const keys = {
    all: [{ entity: 'adresse' }],
    get: (id: string) => mergeKeyWith(keys.all, { id }),
  } as const

  return keys
}

const getIdFromPayload = (payload: AdresseQueryPayload) => {
  const isKvittering = 'bildeIds' in payload

  if (isKvittering) {
    return payload.virksomhetsOrgNr
      ? payload.virksomhetsOrgNr
      : payload.virksomhetsNavn
  }

  return payload.idstring
}

const adresseKeys = getAdresseKeys()

export { adresseKeys, getIdFromPayload }
